// extracted by mini-css-extract-plugin
export default {"separator":"Qlk6q5","postExcerpt":"wcKAEe","postTitle":"GP7t_I"};